<template>
  <div v-if="this.$store.state.server">
    {{test}}
    <!-- {{width}} -->
    <b-row>
      <b-col>
        <b-button class="mt-1" variant="success" @click="next('#/scanlogin')">ScanLogin</b-button>&nbsp;
        <b-button class="mt-1" variant="warning" @click="next('#/scangoods')">ScanGoods</b-button>&nbsp;
        <!-- <b-button variant="warning" @click="postlogin2('มาม่า')">มาม่า</b-button>&nbsp; -->
         <b-button class="mt-1" variant="outline-info" @click="showGoods=!showGoods">ของ</b-button>&nbsp;
        <b-button v-show="showGoods" class="ml-1 mt-1" v-for="item in goods_item" :key="item.name" variant="info" @click="postlogin2(item.name)">{{item.name}}</b-button>
      </b-col>
      <b-col class="text-right">
        <b-row>
          <b-col>
            <span style="font-size: 30px;">รวม : {{ sum_print }} </span>
          </b-col>
          <b-col>
            <b-form-input
              size="lg"
              type="number"
              v-model="money_receive"
            ></b-form-input>
          </b-col>
          <b-col>
            <span style="font-size: 30px;">ทอน : {{ (money_receive - sum_print) > 0 ? (money_receive - sum_print) : '' }} </span>
          </b-col>
          <b-col>
            <b-button v-print="printObj" type="success" style="font-size: 30px">
              <span class="btn-inner--icon">
                <img src="@/assets/print.png" />
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <!-- <b-button variant="warning" @click="next('#/scantime')">ScanTime</b-button>&nbsp; -->
      <!-- <b-button variant="primary" @click="next('#/scan3hr')">Scan3hr</b-button>&nbsp; -->
      <!-- <b-button @click="next('#/qr')">QR</b-button> -->
    </b-row>
    <br />
    <b-row>
      <b-button size="sm" @click="nextday(-1)">-</b-button>
      <b-col sm="2">
        <b-form-input size="sm" type="date" v-model="currentDate" class="text-center"></b-form-input>
      </b-col>
      <b-button size="sm" @click="nextday(1)">+</b-button>
    </b-row>
    <b-row>
      <b-table small striped hover v-show="width <1008" :items="items" :fields="fields0" >
        <template v-slot:cell(qr)="data">
          <div class="text-nowrap">
            <b-button size="sm" @click="deletebyid(data.item.id)">X</b-button>
            <b-button
              variant="outline-success"
              v-if="data.item.status==0"
              size="sm"
              @click="data.item.status = 1"
            >{{data.item.qr}}</b-button>
            <b-button
              variant="outline-danger"
              v-else
              size="sm"
              @click="data.item.status = 0"
            >{{data.item.qr}}</b-button>
            <!-- <label v-if="data.item.status==0" style="color:green;">{{data.item.qr}}</label>
            <label v-else style="color:red;">{{data.item.qr}}</label>-->
          </div>
        </template>
        <template v-slot:cell(login)="data">
          <!-- {{data.item.login}} -->
           <!-- only show date -->
           {{data.item.login.split(' ')[1].split(':')[0] + ':' + data.item.login.split(' ')[1].split(':')[1]}}
        </template>
        <template v-slot:cell(logout)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="datetime"
            v-model="data.item.logout"
          ></b-form-input>
        </template>
        <template v-slot:cell(minute)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.minute"
          ></b-form-input>
        </template>
        <template v-slot:cell(price)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.price"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods8)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods8"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods10)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods10"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods13)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods13"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods15)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods15"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods20)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods20"
          ></b-form-input>
        </template>
        <template v-slot:cell(goodsother)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goodsother"
          ></b-form-input>
        </template>
        <template v-slot:cell(note)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="text"
            v-model="data.item.note"
          ></b-form-input>
        </template>
        <template v-slot:cell(total)="data">
          <b-form-input
            size="sm"
            type="number"
            v-model="data.item.total"
            style="background-color:white;color:green;font-weight: bold;"
          ></b-form-input>
        </template>
        <template v-slot:cell(update)="data">
          <div class="text-nowrap">
            <b-button size="sm" variant="primary" @click="update50(data.item)">10%</b-button> &nbsp; 
            <b-button size="sm" variant="warning" @click="updatebyid(data.item)">บันทึก</b-button>
          </div>
        </template>
        <!-- <template v-slot:cell(status)="data">
          <b-form-input size="sm" type="number" v-model="data.item.status"></b-form-input>
        </template>-->
      </b-table>
    </b-row>
    <b-row>
      <b-table
        small
        striped
        hover
        v-show="width >=1008"
        :items="items"
        :fields="fields"
        class="table table-striped header-fixed"
        sort-by="logout" :sort-desc="true"
      >
        <template v-slot:cell(qr)="data">
          <div class="text-nowrap">
            <b-button size="sm" @click="deletebyid(data.item.id)">X</b-button>
            <b-button
              variant="outline-success"
              v-if="data.item.status==0"
              size="sm"
              @click="data.item.status = 1"
            >{{data.item.qr}}</b-button>
            <b-button
              variant="outline-danger"
              v-else
              size="sm"
              @click="data.item.status = 0"
            >{{data.item.qr}}</b-button>
            <!-- <label v-if="data.item.status==0" style="color:green;">{{data.item.qr}}</label>
            <label v-else style="color:red;">{{data.item.qr}}</label>-->
          </div>
        </template>
        <template v-slot:cell(login)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="datetime"
            v-model="data.item.login"
          ></b-form-input>
        </template>
        <template v-slot:cell(logout)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="datetime"
            v-model="data.item.logout"
          ></b-form-input>
        </template>
        <template v-slot:cell(minute)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.minute"
          ></b-form-input>
        </template>
        <template v-slot:cell(price)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.price"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods8)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods8"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods10)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods10"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods13)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods13"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods15)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods15"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods20)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods20"
          ></b-form-input>
        </template>
        <template v-slot:cell(goodsother)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goodsother"
          ></b-form-input>
        </template>
        <template v-slot:cell(note)="data">
          <b-row class="text-nowrap">
            <b-col cols="1">
              <b-button size="sm" variant="info" @click="updateSod(data.item)">สด</b-button>
            </b-col>
            <b-col cols="9">
              <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="text"
            v-model="data.item.note"
              ></b-form-input>
            </b-col>
          </b-row>
        </template>
        <template v-slot:cell(total)="data">
          <b-form-input
            size="sm"
            type="number"
            v-model="data.item.total"
            style="background-color:white;color:green;font-weight: bold;"
          ></b-form-input>
        </template>
        <template v-slot:cell(update)="data">
          <!-- for desktop -->
          <div class="text-nowrap">
            <b-button size="sm" variant="primary" @click="update50(data.item)">10%</b-button> &nbsp; 
            <b-button size="sm" variant="warning" @click="updatebyid(data.item)">บันทึก</b-button> &nbsp; 
          </div>
        </template>
        <template v-slot:cell(print)="data">
          <b-row class="text-center">
            <b-col>
              <b-form-checkbox size="lg" v-model="data.item.print">พิมพ์</b-form-checkbox>
            </b-col>
          </b-row>
        </template>
        <!-- <template v-slot:cell(status)="data">
          <b-form-input size="sm" type="number" v-model="data.item.status"></b-form-input>
        </template>-->
      </b-table>
    </b-row>
    <b-row>
      <h4>รวมทั้งหมด</h4>
    </b-row>
    <b-row>
      <b-table small striped hover :items="items2" :fields="fields2">
        <template v-slot:cell(minute)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="sum"
          ></b-form-input>
        </template>
        <template v-slot:cell(price)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.price"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods8)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods8"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods10)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods10"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods13)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods13"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods15)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods15"
          ></b-form-input>
        </template>
        <template v-slot:cell(goods20)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goods20"
          ></b-form-input>
        </template>
        <template v-slot:cell(goodsother)="data">
          <b-form-input
            @focus.native="tablefcous = true"
            @blur.native="tablefcous = false"
            size="sm"
            type="number"
            v-model="data.item.goodsother"
          ></b-form-input>
        </template>
        <template v-slot:cell(total)="data">
          <b-form-input
            size="sm"
            type="number"
            v-model="data.item.total"
            style="background-color:white;color:green;font-weight: bold;"
          ></b-form-input>
        </template>
        <template v-slot:cell(update)="data">
          <div class="text-nowrap">
            <b-button size="sm" variant="primary" @click="update50(data.item)">10%</b-button> &nbsp; 
            <b-button size="sm" variant="warning" @click="updatebyid(data.item)">บันทึก</b-button>
          </div>
        </template>
        <!-- <template v-slot:cell(status)="data">
          <b-form-input size="sm" type="number" v-model="data.item.status"></b-form-input>
        </template>-->
      </b-table>
    </b-row>
    <div v-show="false">
      <div id="printMe" style="color: black; font-size: 14px">
        <b-row>
          <!-- <b-col cols="3" class="text-center">
            <img height="200" src="@/assets/head.png" />
          </b-col> -->
          <!-- <b-col cols="3" class="text-center">
            <img height="100" src="@/assets/head.png" />
          </b-col> -->
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            {{ porsor() }}
          </b-col>
        </b-row>
        <b-row>
          <b-col> รายการ </b-col>
        </b-row>
        <b-div v-for="(item, index) in items_print" :key="index">
          <b-row>
            <b-col cols="2" class="text-nowrap text-left">
              QR {{ item.qr }}
            </b-col>
            <b-col cols="1" class="text-nowrap text-right">{{ item.price }} ฿</b-col>
          </b-row>
        </b-div>
        <b-row>
          <b-col>รวม : {{ sum_print }} ฿</b-col>
        </b-row>
        <!-- <b-row>
          <b-col>รับเงิน : {{ money_receive }} ฿</b-col>
        </b-row>
        <b-row>
          <b-col>ทอน : {{ remain }}</b-col>
        </b-row> -->
        <!-- <b-row>
          <b-col cols="3" class="text-center mt-2 mb-1">
            <img height="150" src="@/assets/tail.png" />
          </b-col>
        </b-row> -->
        <b-row>
          <b-col cols="3" class="text-center" style="color: white">|</b-col>
        </b-row>
        <b-row>
          <b-col cols="3" class="text-center" style="color: white">|</b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>

import Print from "vue-print-nb";

export default {
  data() {
    return {
      showGoods: false,
      printObj: {
        id: "printMe",
        popTitle: "good print",
        // extraCss:
        //   "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
        // extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        beforeOpenCallback(vue) {
          // vue.printLoading = true;
          // console.log("打开之前");
        },
        openCallback(vue) { },
        closeCallback(vue) { },
      },
      money_receive: 0,
      sum_print: 0,
      width: 0,
      currentDate: "",
      test: "",
      fields0: [
        {
          key: "qr",
          label: "QR",
          sortable: true,
          thClass: "text-center qr",
          tdClass: "qr"
        },
        {
          key: "login",
          label: "Login",
          sortable: true,
          thClass: "text-center login",
          tdClass: "login"
        },
        {
          key: "hr",
          label: "ชั่วโมง",
          sortable: true,
          thClass: "text-center hr",
          tdClass: "hr"
        },
        // อื่นๆ
        {
          key: "price",
          label: "ค่าบริการ",
          sortable: true,
          thClass: "text-center price",
          tdClass: "price"
        },
        {
          key: "goodsother",
          label: "เครื่องดื่ม",
          thClass: "text-center goodsother",
          tdClass: "goodsother"
        },
        {
          key: "total",
          label: "รวม",
          sortable: true,
          thClass: "text-center price",
          tdClass: "price"
        },
        {
          key: "update",
          label: "10%",
          thClass: "update",
          tdClass: "update"
        },
        {
          key: "note",
          label: "หมายเหตุ",
          sortable: true,
          thClass: "text-center note",
          tdClass: "note"
        },
      ],
      fields: [
        {
          key: "qr",
          label: "QR",
          sortable: true,
          thClass: "text-center qr",
          tdClass: "qr"
        },
        {
          key: "login",
          label: "Login",
          sortable: true,
          thClass: "text-center login",
          tdClass: "login"
        },
        {
          key: "logout",
          label: "Logout",
          sortable: true,
          thClass: "text-center login",
          tdClass: "login"
        },
        {
          key: "minute",
          label: "นาที",
          sortable: true,
          thClass: "text-center minute",
          tdClass: "minute"
        },
        {
          key: "hr",
          label: "ชั่วโมง",
          sortable: true,
          thClass: "text-center hr",
          tdClass: "hr"
        },
        {
          key: "price",
          label: "ค่าบริการ",
          sortable: true,
          thClass: "text-center price",
          tdClass: "price"
        },
        // {
        //   key: "goods8",
        //   label: "#8",
        //   thClass: "text-center goods",
        //   tdClass: "goods"
        // },
        // {
        //   key: "goods10",
        //   label: "#10",
        //   thClass: "text-center goods",
        //   tdClass: "goods"
        // },
        // {
        //   key: "goods13",
        //   label: "#13",
        //   thClass: "text-center goods",
        //   tdClass: "goods"
        // },
        // {
        //   key: "goods15",
        //   label: "#15",
        //   thClass: "text-center goods",
        //   tdClass: "goods"
        // },
        // {
        //   key: "goods20",
        //   label: "#20",
        //   thClass: "text-center goods",
        //   tdClass: "goods"
        // },
        {
          key: "goodsother",
          label: "อื่นๆ",
          thClass: "text-center goodsother",
          tdClass: "goodsother"
        },
        {
          key: "total",
          label: "รวม",
          sortable: true,
          thClass: "text-center price",
          tdClass: "price"
        },
        {
          key: "note",
          label: "หมายเหตุ",
          sortable: true,
          thClass: "text-center note",
          tdClass: "note"
        },
        {
          key: "update",
          label: "update",
          thClass: "update",
          tdClass: "update"
        },
        {
          key: "print",
          label: "พิมพ์",
          thClass: "text-center note",
          tdClass: "note"
        }
      ],
      fields2: [
        {
          key: "minute",
          label: "จำนวน"
        },
        {
          key: "price",
          label: "ค่าบริการ"
        },
        // {
        //   key: "goods8",
        //   label: "#8"
        // },
        // {
        //   key: "goods10",
        //   label: "#10"
        // },
        // {
        //   key: "goods13",
        //   label: "#13"
        // },
        // {
        //   key: "goods15",
        //   label: "#15"
        // },
        // {
        //   key: "goods20",
        //   label: "#20"
        // },
        // {
        //   key: "goodsother",
        //   label: "#"
        // },
        {
          key: "total",
          label: "รวมค่าใช้จ่าย"
        }
      ],
      items: [],
      items_print: [],
      items2: [],
      countmax: 7,
      count: 7,
      tablefcous: false,
      sum: 0,
      goods_item: [
        {name: "มาม่า", price: 100}, 
        {name: "ขนม", price: 10}, 
        {name: "ลูกอม", price: 5}, 
        {name: "น้ำเปล่า", price: 10}, 
        {name: "โค้ก", price: 20}, 
        {name: "ข้าว 50", price: 50}, 
        {name: "ข้าว 60", price: 60}, 
        {name: "ข้าว 70", price: 70}, 
        {name: "ไข่ดาว", price: 12}, 
        {name: "พิซซ่า 89", price: 89},
        {name: "พิซซ่า 159", price: 159},
        {name: "พิซซ่า 219", price: 219},
      ]
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.currentDate = new Date().toJSON().slice(0, 10);
    this.getbydate();
    this.interval = setInterval(() => this.refresh(), 1000);
  },
  watch: {
    items: {
      handler(val) {
        this.sum = this.items.length;
        this.count = this.countmax;
        this.items2 = [];
        this.items2.push({
          minute: 0,
          price: 0,
          goods8: 0,
          goods10: 0,
          goods13: 0,
          goods15: 0,
          goods20: 0,
          goodsother: 0,
          total: 0
        });
        this.items_print = [];
        this.sum_print = 0;
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].print) {
            this.items_print.push(this.items[i]);
            this.sum_print += this.items[i].total;
          }
        }
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].hr = this.timeConvert(this.items[i].minute);
          this.items[i].total =
            parseFloat(this.items[i].price) +
            parseFloat(this.items[i].goods8 * 8) +
            parseFloat(this.items[i].goods10 * 10) +
            parseFloat(this.items[i].goods13 * 13) +
            parseFloat(this.items[i].goods15 * 15) +
            parseFloat(this.items[i].goods20 * 20) +
            parseFloat(this.items[i].goodsother);
          //sum
          this.items2[0].minute += parseFloat(this.items[i].minute);
          this.items2[0].price += parseFloat(this.items[i].price);
          this.items2[0].goods8 += parseFloat(this.items[i].goods8);
          this.items2[0].goods10 += parseFloat(this.items[i].goods10);
          this.items2[0].goods13 += parseFloat(this.items[i].goods13);
          this.items2[0].goods15 += parseFloat(this.items[i].goods15);
          this.items2[0].goods20 += parseFloat(this.items[i].goods20);
          this.items2[0].goodsother += parseFloat(this.items[i].goodsother);
          this.items2[0].total += parseFloat(this.items[i].total);
        }
      },
      deep: true
    }
  },
  methods: {
    postlogin2(str) {
      if (str.search("-") > -1) {
        var res = str.split("-");
        var start = parseInt(res[0]);
        var end = parseInt(res[1]);
        for (let i = start; i <= end; i++) {
          var padd = i.toString().padStart(3, "0")
          // console.log(padd);
          this.postlogin(padd);
        }
      } else {
        this.postlogin(str);
      }
    },
    postlogin(qr) {
      if (qr.length == 4) {
        this.posttime(qr);
      } else {
        this.time3hr = "";
      }
      const formData = new FormData();
      formData.append("api", "login");
      formData.append("qr", qr);
      axios
        .post(this.$store.state.api, formData)
        .then((response) => {
          if (response.data.rows.length > 0) {
            this.$refs.modal.show();
            this.total = response.data.rows[0].total;
            this.item = response.data.rows[0];
            // console.log(response.data.rows[0].minute);
            this.item.hour = this.timeConvert(response.data.rows[0].minute);
          } else {
            this.$parent.showAlert(response.data.data, "success");
            this.getbydate();
            // this.back();
          }
        })
        .catch((e) => {});
    },
    porsor() {
      var year = parseInt(this.$moment().format("YYYY")) + 543;
      return (
        this.$moment().format("Do MMM ") +
        year +
        this.$moment().format(" HH:mm:ss")
      );
    },
    refresh() {
      if (this.tablefcous) {
        this.count = this.countmax;
        return;
      }
      this.count--;
      if (this.count < 0) {
        this.count = this.countmax;
        this.getbydate();
      }
    },
    handleResize() {
      this.width = window.innerWidth;
    },
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rhours + " : " + rminutes;
    },
    nextday(day) {
      var d = new Date(this.currentDate);
      var nd = new Date(d);
      nd.setDate(d.getDate() + day);
      this.currentDate = nd.toJSON().slice(0, 10);
      this.getbydate();
    },
    updatebyid(item) {
      const formData = new FormData();
      formData.append("api", "update");
      formData.append("item", JSON.stringify(item));
      axios
        .post(this.$store.state.api, formData)
        .then(response => {
          this.$parent.showAlert(response.data.data, "success");
          this.getbydate();
        })
        .catch(e => {});
    },
    update50(item) {
      this.updatebyid({
        ...item,
        price: Math.floor(item.price * 0.9)
      });
    },
    updateSod(item) {
      this.updatebyid({
        ...item,
        note: "สด"
      });
    },
    updatestatus(id) {
      // console.log(this.items[id]);
      this.items[id].status = !this.items[id].status;
      // this.updatebyid(this.item[id]);
    },
    deletebyid(id) {
      const formData = new FormData();
      formData.append("api", "delete");
      formData.append("id", id);
      axios
        .post(this.$store.state.api, formData)
        .then(response => {
          this.$parent.showAlert(response.data.data, "success");
          this.getbydate();
        })
        .catch(e => {});
    },
    getbydate() {
      const formData = new FormData();
      formData.append("api", "list");
      formData.append("date", this.currentDate);
      axios
        .post(this.$store.state.api, formData)
        .then(response => {
          var rows = response.data.rows;
          this.items = rows;
          this.items = [];
          for (let i = 0; i < rows.length; i++) {
            this.items.push({
              id: rows[i].id,
              qr: rows[i].qr,
              login: rows[i].login,
              logout: rows[i].logout,
              minute: rows[i].minute,
              hr: this.timeConvert(rows[i].minute),
              price: rows[i].price,
              goods8: rows[i].goods8,
              goods10: rows[i].goods10,
              goods13: rows[i].goods13,
              goods15: rows[i].goods15,
              goods20: rows[i].goods20,
              goodsother: rows[i].goodsother,
              total: rows[i].total,
              status: rows[i].status,
              note: rows[i].note,
              update: rows[i].id
            });
          }
        })
        .catch(e => {});
    },
    next(web) {
      window.location.href = web;
    }
  }
};
</script>

<style>
.header-fixed {
  width: 100%;
}

.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}

.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}

.header-fixed > tbody {
  overflow-y: auto;
  height: 900px;
}
.header-fixed > tbody > tr > td {
  width: 8.3%;
  float: left;
}
.header-fixed > thead > tr > th {
  width: 8.3%;
  float: left;
}
.header-fixed > thead > tr > .goods {
  width: 4%;
  float: left;
}
.header-fixed > tbody > tr > .goods {
  width: 7%;
  float: left;
}
.header-fixed > thead > tr > .goodsother {
  width: 7%;
  float: left;
}
.header-fixed > tbody > tr > .goodsother {
  width: 7%;
  float: left;
}
.header-fixed > thead > tr > .login {
  width: 13.3%;
  float: left;
}
.header-fixed > tbody > tr > .login {
  width: 13.3%;
  float: left;
}
.header-fixed > thead > tr > .price {
  width: 7%;
  float: left;
}
.header-fixed > tbody > tr > .price {
  width: 7%;
  float: left;
}
.header-fixed > thead > tr > .minute {
  width: 5%;
  float: left;
}
.header-fixed > tbody > tr > .minute {
  width: 5%;
  float: left;
}
.header-fixed > thead > tr > .hr {
  width: 5%;
  float: left;
}
.header-fixed > tbody > tr > .hr {
  width: 5%;
  float: left;
}
.header-fixed > thead > tr > .note {
  width: 9%;
  float: left;
}
.header-fixed > tbody > tr > .note {
  width: 9%;
  float: left;
}
.header-fixed > thead > tr > .qr {
  width: 10%;
  float: left;
}
.header-fixed > tbody > tr > .qr {
  width: 10%;
  float: left;
}
</style>